import React from 'react';

import { dateToTwoDigitDate } from '@trqk/utils';

interface TuneSatUploadInstructionsProps {
    performancePeriodEnd: Date | null;
    performancePeriodStart: Date | null;
}

export const TuneSatUploadInstructions = ({
    performancePeriodEnd,
    performancePeriodStart,
}: TuneSatUploadInstructionsProps): JSX.Element => {
    const startDateLabel =
        performancePeriodStart !== null
            ? dateToTwoDigitDate(performancePeriodStart)
            : 'your start date';

    const endDateLabel =
        performancePeriodEnd !== null
            ? dateToTwoDigitDate(performancePeriodEnd)
            : 'your end date';

    return (
        <div className="mx-12 text-sm">
            <h5>How to Download TuneSat Detections</h5>
            <ol className="list-decimal mx-10 mt-4">
                <li>
                    Log in to your{' '}
                    <a
                        className="respond-to-mouse underline text-primary-500"
                        href="https://tunesat.com/tunesatportal/home"
                        target="_blank"
                        rel="noreferrer"
                    >
                        TuneSat account
                    </a>
                    .
                </li>
                <li>
                    Click{' '}
                    <span className="font-semibold">Search Detections</span> at
                    the top right. In the Date selectors at the right, enter{' '}
                    <span className="font-semibold">{startDateLabel}</span> in
                    the <span className="italic">Start</span> window. Enter{' '}
                    <span className="font-semibold">{endDateLabel}</span> in the{' '}
                    <span className="italic">End</span> window.
                </li>
                <li>
                    Click <span className="font-semibold">Update</span>.
                </li>
                <li>
                    In the top left navigation menu, click{' '}
                    <span className="font-semibold">Export Detections</span> ,
                    then select <span className="font-semibold">CSV</span> and
                    click <span className="font-semibold">Download</span>.
                </li>
            </ol>
            <p className="mt-4">
                When the report has finished downloading, upload it here.
            </p>
        </div>
    );
};
